export default "__VITE_ASSET__0b5023ad__"